import React, { useEffect, useState } from "react";
import { CiLogin } from "react-icons/ci";
import { FaHome } from "react-icons/fa";

function Header() {
  const [mobile, setMobile] = useState(null);
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "loginMobile") {
        setMobile(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    const storedMobile = sessionStorage.getItem("loginMobile");
    if (storedMobile) {
      setMobile(storedMobile);
    }
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      <header className="w-full shadow-sm">
        {/* Top Header - Logo */}
        <div className="bg-white border-b py-3">
          <div className="container mx-auto flex justify-center items-center">
            <a href="/" aria-label="Homepage">
              <img
                src="/assets/images/logo.png"
                alt="Company Logo"
                className="h-16 object-contain"
              />
            </a>
          </div>
        </div>

        {/* Bottom Header - Navigation */}
        <div className="bg-gray-200 text-white">
          <div className="container mx-auto flex justify-end items-center flex-nowrap py-2 px-4 gap-2 overflow-x-auto">
            <a
              href="/"
              className="flex items-center gap-2 text-blue hover:text-blue-100 transition font-medium text-base flex-shrink-0"
            >
              <FaHome />
              Home
            </a>

            {mobile ? (
              <div className="flex items-center gap-2 rounded-xl shadow-inner flex-nowrap flex-shrink-0">
                {/* Login Info */}
                <span className="flex items-center gap-2 text-blue-700 font-medium text-sm px-4 py-2 shadow-sm rounded-full whitespace-nowrap">
                  <i className="fa fa-user text-blue-600"></i>
                  <span>
                    LOGIN ID:&nbsp;
                    <span className="font-semibold text-gray-800">{mobile}</span>
                  </span>
                </span>

                {/* Logout Button */}
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 bg-red-600 text-white hover:bg-red-700 active:scale-95 transition-all duration-200 px-4 py-2 font-semibold text-sm shadow-md rounded-full whitespace-nowrap"
                >
                  <i className="fa fa-sign-out"></i>
                  Logout
                </button>
              </div>
            ) : (
              <a
                href="/login"
                className="flex items-center gap-2 bg-white text-blue-600 hover:bg-blue-100 transition px-4 py-1.5 font-semibold text-sm shadow-sm rounded flex-shrink-0"
              >
                <CiLogin size={20} />
                Login
              </a>
            )}
          </div>
        </div>

      </header>
    </>
  );
}

export default Header;
